import { FETCH_MANDANT_LOGO } from "../actions/types/mandant-types";
import ConfigStorage from '../storage/config-storage';

export default function reducer(state = ConfigStorage, action) {
  switch (action.type) {
    case 'INIT': {
      let newState = { ...state };
      newState.init(action.payload);
      return newState;
    }
    case 'SET_SESSION_DATA': {
      let newState = { ...state };
      newState.setSessionData(action.payload);
      return newState;
    }
    case 'SET_TAN_AUTH': {
      let newState = { ...state };
      newState.setSessionData(action.payload);
      newState.setTanAuth(true);
      return newState;
    }
    case 'SET_ACTIVE_TIMEOUT': {
      let newState = { ...state };
      newState.setActiveTimeout(action.payload);
      return newState;
    }
    case "auftrag/fetchAuftrag/fulfilled":
    case "auftrag/fetchData/fulfilled":    
    case 'RESET_SESSION': {
      let newState = { ...state };
      newState.resetSession();
      return newState;
    }
    case "RESTART_SESSION": {
      let newState = { ...state };
      newState.resetSession();
      newState.setTanAuth(false);
      return newState;
    }
    case 'SET_AUTH_TOKEN': {
      let newState = { ...state };
      newState.setAuthToken(action.payload);
      return newState;
    }
    case 'SET_BANK_ID': {
      let newState = { ...state };
      newState.setBankId(action.payload);
      return newState;
    }
    case 'SET_RENDER_LANDINGPAGE': {
      let newState = { ...state };
      newState.setRenderLandingPage(action.payload);
      return newState;
    }
    case 'SET_TIMEOUT_POPUP_STATUS': {
      let newState = { ...state };
      newState.setTimoutPopupStatus(action.payload);
      return newState;
    }
    case 'SET_APP_ID': {
      let newState = { ...state };
      newState.setAppId(action.payload);
      return newState;
    }
    case 'SET_VERWALTUNG': {
      let newState = { ...state };
      newState.setVerwaltung(action.payload);
      return newState;
    }
    case 'SET_CALLCENTER': {
      let newState = { ...state };
      newState.setCallcenter(action.payload);
      return newState;
    }
    case 'SET_LIGHT_SHOP': {
      let newState = { ...state };
      newState.setLightShop(action.payload);
      return newState;
    }
    case "SET_MASTER_DATA": {
      let newState = { ...state };
      newState.setMasterData(action.stammdaten);
      return newState;
    }
    case "SET_MA_KOND": {
      let newState = { ...state };
      newState.setMitarbeiterKonditionen(action.payload);
      return newState;
    }
    case "REFRESH_PAGE":
    case "RESET_WARENKORB": {
      let newState = { ...state };
      newState.setMitarbeiterKonditionen(false);
      return newState;
    }
    case FETCH_MANDANT_LOGO: {
      let newState = { ...state };
      newState.setMandantLogo(action.logo);
      return newState;
    }
    case "SET_LOADING_MA_KOND": {
      let newState = { ...state };
      newState.setLoadingMaKond(!!action?.payload);
      return newState;
    }
    default: return state;
  }
}
